import { render, staticRenderFns } from "./customer-dimension.vue?vue&type=template&id=6facd536&"
import script from "./customer-dimension.vue?vue&type=script&lang=js&"
export * from "./customer-dimension.vue?vue&type=script&lang=js&"
import style0 from "./customer-dimension.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports